import type { BeverageReceiptWritten, BeverageStockItem } from '@agos/api-client/model'
import { tt } from '@agos/shared'

import { formatQty } from './beverage-tabs'

/**
 * *Zaznamenať príjem* - FRONTEND.md §9.748, owner O122: *"ked dám "Zaznamenať príjem", tak to reálne nepridá"*.
 *
 * The dialog offered **products** and wrote a delivery that moved no stock, reaching a row only through an
 * identical name. It receives one of the stock take's own drinks now (`GET /beverage-stock/items`) onto that
 * drink's own stock (`POST /beverage-stock/receipts`, BACKEND.md §10A.400), so *Príjem* and *Zostatok* move on the
 * row the person was looking at. These are the dialog's rules; the dialog is in `BeverageStockPage.tsx`.
 */

/**
 * The typed quantity, or null when it cannot be received - blank, not a number, nought or less.
 *
 * A comma is the decimal point here (*0,5*). A blank box needs no case of its own: `Number('')` is 0, and nought
 * is refused like any quantity that adds nothing.
 */
export function receiptAmount(typed: string): number | null {
  const amount = Number(typed.trim().replace(',', '.'))
  return Number.isFinite(amount) && amount > 0 ? amount : null
}

/** One drink in the select: its name, and its category when it has one - the row's own two columns. */
export function drinkOption(drink: Pick<BeverageStockItem, 'name' | 'category'>): string {
  const category = drink.category?.trim() ?? ''
  return category === '' ? drink.name : `${drink.name} · ${category}`
}

/** The quantity's label in the drink's own unit, so *24* means 24 of what the row counts. */
export function quantityLabel(unit: string | null | undefined): string {
  const named = unit?.trim() ?? ''
  return named === '' ? tt('Množstvo') : `${tt('Množstvo')} (${named})`
}

/** What is on the shelf now, in the drink's unit - shown before the quantity is typed. */
export function levelNote(drink: Pick<BeverageStockItem, 'qty' | 'unit'>): string {
  return `${tt('Na sklade')}: ${formatQty(drink.qty, drink.unit ?? undefined)}`
}

/** The toast after a receipt: the drink, what came, and the level it brought the shelf to. */
export function receivedNote(
  written: Pick<BeverageReceiptWritten, 'name' | 'qty' | 'unit' | 'stockQty'>,
): string {
  const unit = written.unit ?? undefined
  return `${written.name}: +${formatQty(written.qty, unit)} - ${tt('na sklade')} ${formatQty(written.stockQty, unit)}`
}
